"use strict";
// Only to be used for: https://git.hubteam.com/HubSpot/CRM-Issues/issues/647
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _generalStore = require("general-store");

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _UserStore = _interopRequireDefault(require("crm_data/user/UserStore"));

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _SubjectPermissions = require("crm_ui/utils/SubjectPermissions");

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _MetaApiStatusStore = require("crm_data/meta/MetaApiStatusStore");

var _MetaApiConstants = require("crm_data/meta/MetaApiConstants");

function _default(Component) {
  var RoutedProfilePermissionsContainer =
  /*#__PURE__*/
  function (_PureComponent) {
    (0, _inherits2.default)(RoutedProfilePermissionsContainer, _PureComponent);

    function RoutedProfilePermissionsContainer() {
      var _this;

      (0, _classCallCheck2.default)(this, RoutedProfilePermissionsContainer);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RoutedProfilePermissionsContainer).call(this));
      _this.hasViewPermission = _this.hasViewPermission.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(RoutedProfilePermissionsContainer, [{
      key: "checkGates",
      value: function checkGates(checkPermissionFn) {
        var _this$props = this.props,
            isExempt = _this$props.isExempt,
            subject = _this$props.subject,
            user = _this$props.user;

        if ([subject, user, isExempt].includes(undefined)) {
          return undefined;
        }

        return isExempt ? true : checkPermissionFn();
      }
    }, {
      key: "hasViewPermission",
      value: function hasViewPermission() {
        var subject = this.props.subject;
        return (0, _SubjectPermissions.recordIsNewlyCreated)(subject) || (0, _SubjectPermissions.canView)(subject);
      }
    }, {
      key: "render",
      value: function render() {
        // if the MetaAPI status is unauthorized we should assume the user
        // is attempting to view an object they don't have access to
        var canViewProfile = this.props.metaApiUnauthorized ? false : this.checkGates(this.hasViewPermission);
        return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
          canViewProfile: canViewProfile
        }));
      }
    }]);
    return RoutedProfilePermissionsContainer;
  }(_PureComponent2.default);

  RoutedProfilePermissionsContainer.propTypes = {
    isExempt: _propTypes.default.bool,
    metaApiUnauthorized: _propTypes.default.bool,
    objectType: _ObjectTypesType.default,
    subject: _SubjectType.default,
    subjectId: _propTypes.default.string.isRequired,
    user: _propTypes.default.object
  };
  var dependencies = {
    user: _UserStore.default,
    subject: _SubjectDependency.default,
    isExempt: {
      stores: [_IsUngatedStore.default],
      deref: function deref() {
        var gate = 'CRM:permissionslockdownexempt';
        var isExempt = _IsUngatedStore.default.get(gate) === true;

        if ((0, _LoadingStatus.isLoading)(isExempt)) {
          return undefined;
        }

        return isExempt;
      }
    },
    metaApiUnauthorized: {
      stores: [_MetaApiStatusStore.MetaApiStatusStore],
      deref: function deref() {
        return _MetaApiStatusStore.MetaApiStatusStore.get() === _MetaApiConstants.UNAUTHORIZED;
      }
    }
  };
  return (0, _generalStore.connect)(dependencies)(RoutedProfilePermissionsContainer);
}

module.exports = exports.default;